module.exports = __webpack_public_path__ + "static/media/Background5.26f3afbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Backgrounds/Background5.png
// module id = 256
// module chunks = 0